import React from 'react';
import { SnackbarProvider } from 'notistack';
import { outlinedNotistackComponents } from './OutlinedAlertSnackbar';

type Props = { children: React.ReactNode };

/**
 * アプリ全体の notistack
 * 右下に Outlined Alert を表示する
 */
export function AppNotistackProvider({ children }: Props) {
  return (
    <SnackbarProvider
      maxSnack={3}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      autoHideDuration={5000}
      preventDuplicate  // 同じメッセージの Snackbar を短い間隔で積まない
      Components={outlinedNotistackComponents}
    >
      {children}
    </SnackbarProvider>
  );
}
